import * as d from "@/utils/dataUtils";

export const defaultFormModel = {
  image: null,
  salutation: null,
  title: null,
  firstName: "",
  lastName: "",
  mobile: "",
  landline: "",
  mobileIsBusiness: false,
  userRole: "",
  email: "",
  confirmEmail: "",
  password: "",
  confirmPassword: "",
};

export function prepareProfileSettingsForLoad(data: any) {
  return {
    ...data,
    salutation: d.loadSelect(data.salutation),
    title: d.loadSelect(data.title),
    confirmEmail: data.email,
    password: "",
    confirmPassword: "",
  };
}

export async function prepareProfileSettingsForSave(data: any) {
  const payload: any = {
    ...data,
    salutation: d.saveSelect(data.salutation),
    title: d.saveSelect(data.title),
  };

  if (data.image instanceof File) {
    payload.image = await d.fileToBase64(data.image);
  } else {
    // Entferntes Bild kommt als null an. Der Server unterscheidet
    // "nicht mitgeschickt" (Bild bleibt) von "" (Bild loeschen) – null
    // wuerde als "nicht mitgeschickt" gelesen und nichts loeschen.
    payload.image = data.image ?? "";
  }

  return payload;
}
